<template>
  <div class="clock">
    <span
      :class="{ time: !running, 'time-running': running }"
      :id="this.clockId"
      v-if="mode != 'reply'"
      >{{ timeNew }}
      <p
        class="running-indicator"
        :class="{ 'running-indicator-active': whoWorksOnTaskNow.length > 0 }"
        v-if="mode == 'standBy'"
      ></p
    ></span>
  </div>
</template>

<script>
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
import {mapGetters, mapState} from "vuex";

export default {
  name: "TaskClock",
  data() {
    return {
      clockId:
        this.mode == "standBy"
          ? "clock#" + this.task_id
          : "clock#" + this.task_id + "r",
      // dataFromDB: null,
      currentUserShift: [],
      inWaiting: false,
      running: false,
      started: null,
      whoWorksOnTaskNow: [],
      stoppedDuration: 0,
      time: "00:00:00",
      timeNew: moment("00:00:00", "HH:mm:ss").format("HH:mm:ss"),
      // setInterval(()=>{this.copyTimer = moment(this.copyTimer,'hh:mm:ss').add(1, 'seconds').format('hh:mm:ss')
      // }, 1000)
      timeBegan: null,
      timeStopped: null,
      copyTimer: "00:00:00",
      // timeBeganLatest: moment(),
      timeBeganLatest: moment().format(),
      // timeBeganLatest: new Date(),
      // refreshIntervalId: setInterval(this.timerRuns, 1000)
      refreshIntervalId: this.running
        ? setInterval(this.timerRuns, 1000)
        : null,
      shiftCheckInterval: this.running
        ? setInterval(this.checkUserShift, 1000)
        : null
      // refreshIntervalId: null
    };
  },
  props: {
    forceStopTimer: {
      type: Boolean
    },
    showAll: {
      type: Boolean
    },
    mode: {
      type: String
    },
    selectedMainTab: {
      type: String
    },
    task_id: {
      type: Number
    },
    task: {
      type: Object
    },
    times_arr: {
      type: Array
    },
    user_id: {
      type: Number
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapState("tasks", ["activeTimer", "taskDictionaries", "stopTimer"])
  },
  methods: {
    timerRuns() {
      if (this.running) {
        this.timeNew = moment(this.timeNew, "HH:mm:ss")
          .add(1, "seconds")
          .format("HH:mm:ss");
      }
    },
    // Triggers checking work time with interval 1 min
    checkUserShift() {
      this.auth.user.user_shifts.length > 0 &&
      !this.checkIfCurrentTimeInUserShifts(
        this.auth.user.user_shifts[0].start,
        this.auth.user.user_shifts[0].finish
      )
        ? this.stopNew()
        : null;
    },
    //Function checks if current time is in user today shift. | Gets two strings(start, finish) | Returns boolean
    checkIfCurrentTimeInUserShifts(start, finish) {
      return moment().isBetween(
        moment(start, "HH:mm"),
        moment(finish, "HH:mm")
      );
    },
    forceStart() {
      if(this.auth.user.user_shifts.length > 0 && this.checkIfCurrentTimeInUserShifts(this.auth.user.user_shifts[0].start, this.auth.user.user_shifts[0].finish)){ // Checks if current time in user today shifts
        this.running = true;
        clearInterval(this.refreshIntervalId);
        clearInterval(this.shiftCheckInterval);
        this.refreshIntervalId = setInterval(this.timerRuns, 1000);
        this.shiftCheckInterval = setInterval(this.checkUserShift, 2000);
        if (
            document.getElementById(`${this.clockId}`) &&
            this.selectedMainTab !== "waiting"
        ) {
          document.getElementById(`${this.clockId}`).style.color = "red";
        }
      }else{
        this.stopNew()
      }

    },
    stopNew() {
      this.running = false;
      clearInterval(this.refreshIntervalId);
      clearInterval(this.shiftCheckInterval);
      this.shiftCheckInterval = null;
      this.refreshIntervalId = null;
      if (document.getElementById(`${this.clockId}`)) {
        document.getElementById(`${this.clockId}`).style.color = "#44a2d2";
      }
    },
    updateTime() {
      apiClientCreator(`tasks/time/${this.task_id}`)
        .put("", {
          time: this.timeNew,
          time_stopped: moment().format(),
          // time_stopped:this.timeStopped!== null? moment(this.timeStopped).format("YYYY-MM-DD HH:mm:s"): null,
          // stopped_duration: this.stoppedDuration,
          // started: this.started,
          running: this.running,
          timeBeganLatest: this.timeBeganLatest,
          timeBegan:
            this.timeBegan == null
              ? moment().format()
              : moment(this.timeBegan).format()
          // timeBegan: this.timeBegan == null ? moment().add(3, "hours").format(): this.timeBegan
        })
        .then(res => {})
        .catch(err => {});
    },
    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });
      return originalCreator;
    },
    ifSomebodyWorksOnTask() {
      let temp = this.task.task_time_duration.filter(timer => {
        return timer.running == true || timer.running == 1;
      });
      this.whoWorksOnTaskNow = temp;
    },
    isTaskExecutor() {
      let isTaskExecutor = false;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === this.auth.user.id) {
          isTaskExecutor = true;
        }
      });

      return isTaskExecutor;
    },
    getTimeWithoutNonWorkHours(updTime, data) {
      let timeNow = moment();
      // var isafter = moment(date_time).isAfter('2014-03-24T01:14:00Z');
      if (timeNow.date() === moment(data.time_began_latest).date()) {
        if (this.currentUserShift.finish == null) {
        }
      } else if (timeNow.date() > moment(data.time_began_latest).date()) {
      }
    },
    getTimerFromDB() {
      apiClientCreator(`tasks/time/${this.task_id}`)
        .get("")
        .then(res => {
          if (res.data != "time for this task not exists") {
            this.timeBeganLatest = res.data.time_began_latest;
            this.timeStopped = res.data.time_stopped;
            let timeNow = moment();
            let timeEnd = moment(res.data.time_stopped);
            let timeDiff = timeNow.diff(timeEnd);
            let timeFromDb = res.data.time;
            let updTime = moment(timeFromDb, "HH:mm:ss")
              .add(timeDiff, "milliseconds")
              .format("HH:mm:ss");

            if (res.data.running == true || res.data.running == 1) {

              // this.getTimeWithoutNonWorkHours(updTime, res.data); // PLEASE DON`T REMOVE THIS
              // this.timeNew = this.getTimeWithoutNonWorkHours(updTime, res.data);
              this.timeNew = updTime;
            } else {
              this.timeNew = res.data.time;
            }
            this.running = res.data.running;
            if (this.running) {
              this.forceStart();
            }
          } else {
          }
        })
        .catch(err => {});
    },
    getTimeForTabWaiting(timeOfExecutor) {
      //TODO kobi
      this.timeBeganLatest = timeOfExecutor.time_began_latest == undefined ? '' : timeOfExecutor.time_began_latest;
      this.timeStopped = timeOfExecutor.time_stopped;
      let timeNow = moment();
      let timeEnd = moment(timeOfExecutor.time_stopped);
      let timeDiff = timeNow.diff(timeEnd);
      let timeFromDb = timeOfExecutor.time;
      let updTime = moment(timeFromDb, "HH:mm:ss")
        .add(timeDiff, "milliseconds")
        .format("HH:mm:ss");
      if (timeOfExecutor.running == true || timeOfExecutor.running == 1) {
        this.timeNew = updTime;
      } else {
        this.timeNew = timeOfExecutor.time;
      }
      this.running = timeOfExecutor.running;
      if (this.running) {
        this.forceStart();
      }
    },
    checkUserPermissionForStartTimer() {
      // if(this.auth.user.id !== this.getOriginalCreator() && this.auth.user.role !== 1 && this.auth.user.role !== 2){
      if (this.auth.user.id === this.getOriginalCreator()) {
        return false;
      } else {
        if (this.auth.user.role === 1 || this.auth.user.role === 2) {
          if (this.isTaskExecutor()) {
            return true;
          }
          return false;
        }
        return true;
      }
      //   task.task_assignment[0]
      // } && this.auth.user.role !== 1 && this.auth.user.role !== 2){
      //   return true
      // } else {
      //   return false
      // }
    },
    setTimeOfActiveUser() {
      let activeUser = this.task.task_process_log[0].to_user.id;
      let timeOfActiveUser = this.task.task_time_duration.find(item => {
        return item.user.id === activeUser;
      });
      if (timeOfActiveUser) {
        this.getTimeForTabWaiting(timeOfActiveUser);
      }
    }
  },
  beforeMount() {
    this.currentUserShift = this.dictionaries.general.global_shifts.find(
      item => {
        return item.shift_role_id === this.auth.user.role;
      }
    );
  },
  mounted() {
    this.$root.$on("task_opened_start_working", async data => {
      if (this.mode === "standBy") {
        if (this.task_id === data) {
          if (this.checkUserPermissionForStartTimer()) {
            this.forceStart();
            this.timeBeganLatest = moment().format();

            this.updateTime();
          }
        } else {
          // this.$root.$off("task_opened_start_working");
          if (this.running) {
            this.running = false;
            this.stopNew();
            this.timeStopped = moment().format();
            this.updateTime();
          }
        }
      }
    });
    this.$root.$on("task_transfer", async data => {
      if (this.mode === "standBy") {
        if (this.task_id === data) {
          this.running = false;
          this.stopNew();
          this.timeStopped = moment().format();
          this.updateTime();
        }
      }
    });
    this.$root.$on("task_check_timer_stop", data => {
      if (this.mode === "standBy") {
        if (this.task_id === data) {
          this.running = false;
          this.stopNew();
          this.timeStopped = moment().format();
          // this.updateTime();
        }
      }
    });
    this.$root.$on("task_replied", data => {
      if (this.mode === "standBy") {
        if (this.task_id === data) {
          this.running = false;
          this.stopNew();
          this.timeStopped = moment().format();
          this.updateTime();
        }
      }
    });

    if (this.mode === "add") {
      this.forceStart();
    } else if (this.mode === "standBy") {
      this.ifSomebodyWorksOnTask();
      if (this.selectedMainTab === "waiting") {
        this.inWaiting = true;
        let timeOfExecutor = this.task.task_time_duration[
          this.task.task_time_duration.length - 1
        ];
        this.getTimeForTabWaiting(timeOfExecutor);
      } else if (this.selectedMainTab === "active") {
        this.setTimeOfActiveUser();
      } else {
        this.getTimerFromDB();
      }
    }
  },
  beforeDestroy() {
    this.$root.$off("task_opened_start_working");
    this.$root.$off("task_transfer");
    this.$root.$off("task_replied");
    // this.$root.$off("task_check_timer_stop");
  },
  destroyed() {
    if (this.mode === "standBy") {
      if ((this.running === true || this.running === 1) && !this.inWaiting) {
        if(this.auth.user.user_shifts.length > 0 && !this.checkIfCurrentTimeInUserShifts(this.auth.user.user_shifts[0].start, this.auth.user.user_shifts[0].finish)){
          this.stopNew()
        }
        this.updateTime();
      }
    } else if (this.mode === "add") {
    }
  },
  watch: {
    timeNew: function() {
      // this.$emit("setAddNewTaskTimeDuration", moment().diff(this.timeBegan));
      this.$emit("setAddNewTaskTimeDuration", this.timeNew);
      // if (this.mode === "standBy" || this.mode === "add") {
      let activeTimer = {
        // clockId: this.clockId,
        // dataFromDB: this.dataFromDB,
        running: this.running,
        // started: this.started,
        // stoppedDuration: this.stoppedDuration,
        time: this.timeNew,
        timeBegan: this.timeBegan == null ? moment().format() : this.timeBegan,
        // // timeBegan: this.timeBegan == null? new Date() : this.timeBegan,
        // timeStopped: this.timeStopped,
        task_id: this.task_id
      };
      this.$store.commit("tasks/setActiveTimer", { activeTimer });
      // }
    }
    // showAll: function () {
    // },
  }
};
</script>

<style scoped lang="scss">
$color: #44a2d2;

$color-light: red;

@import url("https://fonts.googleapis.com/css?family=Share+Tech+Mono");

html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

body {
  background-color: rgb(10, 10, 10);
  font-family: "Share Tech Mono", sans-serif;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
}

a {
  cursor: pointer;
}
.time-running {
  font-size: 1em;
  /*margin-right: 10px;*/
  color: red;
}
.clock {
  position: relative;
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  display: inline-flex;
  color: $color;
  //text-shadow: 0px 0px 25px $color;

  .time {
    font-size: 1em;
    /*margin-right: 10px;*/
    color: #44a2d2;
  }

  .text {
    margin-top: 30px;
    font-size: 1em;
    color: rgba($color, 0.15);
    text-align: center;

    a {
      text-decoration: none;
      color: inherit;
      cursor: pointer;

      transition: color 0.1s ease-out;

      &:hover {
        color: $color;
      }
    }
  }

  .btn-container {
    display: flex;
    margin-top: 15px;

    a {
      text-align: center;
      font-family: "Share Tech Mono", sans-serif;
      background: transparent;
      //border: 3px solid $color;
      border: none;
      color: $color;
      padding: 10px 15px;
      margin: 0 10px;
      text-transform: uppercase;
      font-size: 1em;
      cursor: pointer;
      //text-shadow: 0px 0px 10px $color;

      flex-grow: 1;

      transition: color 0.1s ease-out;

      &:hover {
        color: $color-light;
      }
    }
  }
  .active-timer {
    background-color: #0fb97b;
  }
  .running-indicator {
    position: absolute;
    height: 5px;
    width: 5px;
    background-color: grey;
    top: 6px;
    right: 48px;
  }
  .running-indicator-active {
    background-color: #00a700;
  }
}
</style>
